import React, { useState } from "react";
import "./RestaurantDetailsModal.css";
import RejectApplicationModal from "./RejectApplicationModal";
import close from "../../Assets/close.svg";
import { useARMAction } from "../../hooks/useApplications";

const RestaurantDetailsModal = ({ open, onClose, data, userDesignation, onARMAction }) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const armActionMutation = useARMAction();

  if (!open) return null;

  const { restaurant, documents, application } = data || {};

  const handleReject = () => {
    setShowRejectModal(true);
  };

  const handleRejectClose = () => {
    setShowRejectModal(false);
  };

  const handleRejectConfirm = (reason) => {
    if (userDesignation === 'ARM') {
      armActionMutation.mutate({ 
        applicationId: application._id, 
        action: 'reject', 
        rejectionReason: reason 
      }, {
        onSuccess: () => {
          onClose();
        }
      });
    } else if (onARMAction) {
      onARMAction(application._id, 'reject', reason);
    }
    setShowRejectModal(false);
  };

  const handleApprove = () => {
    if (userDesignation === 'ARM') {
      armActionMutation.mutate({ 
        applicationId: application._id, 
        action: 'approve' 
      }, {
        onSuccess: () => {
          onClose();
        }
      });
    } else if (onARMAction) {
      onARMAction(application._id, 'approve');
    }
  };

  const getSignedUrl = (docLink) => {
    return docLink?.signedUrl || docLink?.docUrl || '#';
  };

  // const getDocumentByType = (type) => {
  //   return documents?.documentLink?.find(doc => 
  //     doc.fileType?.toLowerCase().includes(type.toLowerCase())
  //   );
  // };

  return (
    <div className="modal-overlay">
      <div className="modal-container">

        {/* Header */}
        <div className="modal-header">
          <h3>Restaurant Details</h3>
          <button className="close-btn" onClick={onClose}>
            <img src={close} alt="" />
          </button>
        </div>

        {/* Body Content */}
        <div className="modal-body">

          {/* Left Column */}
          <div className="modal-column">
            <p><strong>Category :</strong> {data?.restaurant?.restaurantKind === 0 ? 'Takeaway & Dine In' : data?.restaurant?.restaurantKind === 1 ? 'Take Away' : 'Dine In'}</p>
            <p><strong>Restaurant Name :</strong> {restaurant?.restaurantName || 'N/A'}</p>
            <p><strong>Owner Name :</strong> {restaurant?.ownerDetails?.name || 'N/A'}</p>
            <p><strong>Owner Email :</strong> {restaurant?.ownerDetails?.email || 'N/A'}</p>
            <p><strong>Owner Contact No :</strong> {restaurant?.ownerDetails?.phoneNumber || 'N/A'}</p>
            <p><strong>Owner WhatsApp No :</strong> {restaurant?.ownerDetails?.whatsappNumber || restaurant?.ownerDetails?.phoneNumber || 'N/A'}</p>

            <p><strong>Restaurant Image :</strong> 
              {(() => {
                const validImages = restaurant?.restaurantImageUrl?.filter(img => img.fileUrl) || [];
                return validImages.length > 0 ? (
                  validImages.map((img, index) => (
                    <span key={index}>
                      <a href={img.fileUrl} target="_blank" rel="noopener noreferrer">
                        Img {index + 1}
                      </a>
                      {index < validImages.length - 1 && ' | '}
                    </span>
                  ))
                ) : (
                  <span>Not Available</span>
                );
              })()
              }
            </p>
            
            {restaurant?.menuDetails && restaurant.menuDetails.length > 0 ? (
              restaurant.menuDetails.map((menu, index) => (
                <p key={index}><strong>{menu.menuType || 'Menu'} :</strong> 
                  {menu.signedUrl || menu.docUrl ? (
                    <a href={menu.signedUrl || menu.docUrl} target="_blank" rel="noopener noreferrer">View</a>
                  ) : (
                    <span>Not Available</span>
                  )}
                </p>
              ))
            ) : (
              <p><strong>Menu :</strong> <span>Not Available</span></p>
            )}

            <p><strong>Cuisines Category :</strong> {Array.isArray(restaurant?.cusineType) ? restaurant.cusineType.join('/') : (restaurant?.cusineType || 'N/A')}</p>

            <p><strong>Dine In Waiting Time :</strong> {restaurant?.minWaitingTime ? `${restaurant.minWaitingTime} mins` : 'N/A'}</p>
            <p><strong>Take Away Waiting Time :</strong> {restaurant?.minWaitingTime ? `${restaurant.minWaitingTime} mins` : 'N/A'}</p>

            {documents?.documentLink && documents.documentLink.length > 0 ? (
              documents.documentLink.map((doc, index) => (
                <p key={index}>
                  <strong>{doc.fileType || 'Document'} :</strong> {doc.docData || 'N/A'} /
                  <a href={getSignedUrl(doc)} target="_blank" rel="noopener noreferrer"> View</a>
                </p>
              ))
            ) : (
              <p><strong>Documents :</strong> <span>Not Available</span></p>
            )}

            <p>
              <strong>Restaurant/FSSAI Address :</strong> {restaurant?.restaurantAddressDetails || restaurant?.restaurantAddress?.area || 'N/A'}
            </p>
          </div>

          {/* Right Column */}
          <div className="modal-column">
            <p><strong>Account Holder Name :</strong> {documents?.BankDetails?.AccountHolderName || 'N/A'}</p>
            <p><strong>Bank Name :</strong> {documents?.BankDetails?.BankName || 'N/A'}</p>
            <p><strong>Branch Name :</strong> {documents?.BankDetails?.BranchName || 'N/A'}</p>
            <p><strong>Account Number :</strong> {documents?.BankDetails?.AccountNumber || 'N/A'}</p>
            <p><strong>Account Type :</strong> {documents?.BankDetails?.AccountType || 'N/A'}</p>
            <p><strong>IFSC Code :</strong> {documents?.BankDetails?.IFSCCode || 'N/A'}</p>

            <br />

            <p><strong>Restaurant Timing</strong></p>

            {restaurant?.restaurantTime ? (
              <label>
                All Days ({restaurant.restaurantTime})
              </label>
            ) : (
              ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(day => (
                <label key={day}>
                  {day} (Not Available)
                </label>
              ))
            )}
          </div>
        </div>

        {/* Footer Buttons */}
        {userDesignation === 'ARM' && (
          <div className="modal-footer">
            <button className="reject-btn" onClick={handleReject} disabled={armActionMutation.isPending}>Reject</button>
            <button className="approve-btn" onClick={handleApprove} disabled={armActionMutation.isPending}>
              {armActionMutation.isPending ? 'Processing...' : 'Approve'}
            </button>
          </div>
        )}
      </div>
      
      {showRejectModal && (
        <RejectApplicationModal 
          onClose={handleRejectClose}
          onReject={handleRejectConfirm}
        />
      )}
    </div>
  );
};

export default RestaurantDetailsModal;
